import { render } from "./Modal.vue?vue&type=template&id=21ea009a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=21ea009a&scoped=true&lang=scss"
import "./Modal.vue?vue&type=style&index=1&id=21ea009a&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ea009a"]])

export default __exports__